import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomSnackBarService } from './custom-snack-bar.service';
import { GenericIdbaResponseModel } from '../models/generic-idba-response-model';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  constructor(
    private router: Router,
    private customSnackBar: CustomSnackBarService,
  ) { }

  handleResponse(response: GenericIdbaResponseModel): void {
    if (response.errors?.length > 0) {
      const userMessage = response.errors
        .map((error) => error.description)
        .join('\n');
      this.customSnackBar.openSnackBar(userMessage, null, 'Error');
      return;
    }

    if (response.message && response.message.length > 0) {
      this.customSnackBar.openSnackBar(response.message, null);
    }
  }

  handleError(response: GenericIdbaResponseModel): void {
    if (response?.success) {
      return;
    }

    let userMessage = '';
    if (response.errors?.length) {
      userMessage = response.errors
        .map((error) => error.description)
        .join('\n');
    } else if (response.status !== undefined) {
      switch (response.status) {
        case 0:
          userMessage = 'Serviço indisponível. Verifique a conexão.';
          break;
        case 401:
          userMessage = 'Sua sessão expirou. Faça login novamente.';
          this.router.navigate(['/login']);
          break;
        case 403:
          userMessage = 'Acesso negado.';
          break;
        case 404:
          userMessage = 'Recurso não encontrado.';
          break;
        case 500:
          userMessage = 'Erro interno do servidor.';
          break;
        default:
          userMessage = 'Ocorreu um erro inesperado. Por favor, tente novamente. Se o problema persistir, entre em contato com o suporte.';
      }
    }

    if (userMessage) {
      this.customSnackBar.openSnackBar(userMessage, null, 'Error');
    }
  }
}
